import 'lazysizes';
import './js/utilities/PublicPath';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.lazyClass = 'lazyload';
